import React, { useRef } from 'react';
import styles from '../../../styles/shared/Dialog.module.css';

// Aviso del profesor: confirmación Sí/No (cancelar solicitud) o mensaje con "Cerrar" (ver comentario).
// Mismo diseño que ConfirmationModal (styles/shared/Dialog.module.css).
const Overlay = ({ message, onClose, showConfirmation, onConfirm }) => {
    const overlayRef = useRef();

    const handleClickOutside = (e) => {
        if (overlayRef.current && !overlayRef.current.contains(e.target)) {
            onClose();
        }
    };

    return (
        <div className={styles.overlay} onClick={handleClickOutside}>
            <div className={styles.content} ref={overlayRef} role="dialog" aria-modal="true">
                <p className={styles.message}>{message}</p>
                <div className={styles.buttons}>
                    {showConfirmation ? (
                        <>
                            <button type="button" className={styles.confirmButton} onClick={onConfirm}>Sí</button>
                            <button type="button" className={styles.cancelButton} onClick={onClose}>No</button>
                        </>
                    ) : (
                        <button type="button" className={styles.confirmButton} onClick={onClose}>Cerrar</button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Overlay;
